import { render, staticRenderFns } from "./password-lock.vue?vue&type=template&id=645626fd&"
import script from "./password-lock.vue?vue&type=script&lang=js&"
export * from "./password-lock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports